import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Helmet } from 'react-helmet-async';
// components
import Head from '../../components/UI/Head/Head';
import About from './components/About/About';
import Price from './components/price/Price';
import Arsenal from './components/arsenal/Arsenal';
import Contact from '../../components/Contact/Contact';
import Faq from '../../components/Faq/Faq';
// style
import style from './gamePage.module.css';
// arsenal data
import { Lazertag, Gidraboll, Paintboll } from '../../data/Games';
import { lazerData, pentData, gidraData } from '../../data/Arsenal';

const GamePage = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [loadingPage, setLoadingPage] = useState(true);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Стартуем скролл и загрузку при монтировании
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  // Этот useEffect перезапускает загрузку при смене id
  useEffect(() => {
    setLoadingPage(true);
    document.body.style.overflow = 'hidden';

    const timer = setTimeout(() => {
      setLoadingPage(false);
      document.body.style.overflow = 'visible';
    }, 300);

    return () => {
      clearTimeout(timer);
      document.body.style.overflow = 'visible';
    };
  }, [id]); // ← ключевая часть

  // Fetch data from price API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('/api/2');
        const result = await response.json();
        setData(result);
      } catch (err) {
        setError('Ошибка загрузки данных');
        console.error('Error fetching data:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Filter about game data based on id
  const aboutData =
    id === 'Lasertag-Kazan'
      ? Lazertag
      : id === 'Gidroball-Kazan'
      ? Gidraboll
      : Paintboll;

  // Filter price data based on game name
  const gameFilter = data.filter((card) => card.seo_url === id);

  // Filter arsenal data based on id
  const arsenalFilter =
    id === 'Lasertag-Kazan'
      ? lazerData
      : id === 'Gidroball-Kazan'
      ? gidraData
      : pentData;

  if (loading) {
    return (
      <div className={style.error}>
        <div className="loader"></div>
      </div>
    );
  }

  if (error || gameFilter.length === 0) {
    return (
      <section className={style.error}>
        <div>Ошибка: {error || 'Данные для этой игры не найдены'}</div>
      </section>
    );
  }

  return (
    <>
      <Helmet>
        <title>{aboutData?.title || 'Игра'} — В Казани</title>
        <meta
          name="description"
          content="Играйте в лазертаг, гидробол, пейтбол в Казани с командой Sparta. Оборудование, площадки, арсенал, цены вышего качество."
        />
        <link rel="canonical" href={aboutData.link} />
      </Helmet>
      {loadingPage ? (
        <div className="loaderWrapper">
          <div className="loaderPage"></div>
        </div>
      ) : (
        <main>
          <Head url="/" />
          <div className={style.content}>
            {/* 1 */}
            <About aboutData={aboutData} />
            {/* 2 */}
            <Price item={gameFilter} title={aboutData.title} />
            {/* 3 */}
            <Arsenal arsenalFilter={arsenalFilter} />
            {/* 4 */}
            <Contact
              bg={false}
              text="Остались вопросы? Звоните или отправьте заявку, всё обсудим!"
            />
            {/* 5 */}
            <Faq />
          </div>
          <ToastContainer />
        </main>
      )}
    </>
  );
};

export default GamePage;
